export default "__VITE_ASSET__DWDZWUk2__"